namespace RioERP.Masters {
    export interface StatesForm {
        Name: Serenity.StringEditor;
        IsHomeState: Serenity.BooleanEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class StatesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.States';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StatesForm.init)  {
                StatesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(StatesForm, [
                    'Name', w0,
                    'IsHomeState', w1,
                    'IsActive', w1
                ]);
            }
        }
    }
}
